export const environment = {
  production: false,
  development: true,
  localhost: false,
  apiIsProxy: true,
  envName: 'dev',
  heroBannerImagePath: 'assets/img/webflow/daz_lol.jpg',
  omniChannelAPI: 'https://xpdev-std-svc.np.orikan.tech/api',
  appFlavor: 'OmniChannel',
  appName: 'PayStay',
  applicationVersion: '100',
  applicationPlatform: 'web',
  retyCount: 1,

  reCaptchaKey: '6LdUmCcsAAAAALhMCq9-d5zAZYl7LHiwSD6d7f9N',

  amexEnabled: true,
  fatZebraTestMode: true,

  googlePayEnvironment: "TEST",
  googlePayGatewayName: "fatzebra",
  googlePayGatewayMerchantId: "TESTOrikan-aec81d4df2b7e5d9",
  googlePayMerchantName: "Example",
  googlePayMerchantId: "TODO",

  firebaseConfig: {
    apiKey: "AIzaSyAkkRfP5_Lk0JlxqD9vUNORAz5a7ayrQ6w",
    authDomain: "omni-dev-qa-uat-preprod-112ea.firebaseapp.com",
    projectId: "omni-dev-qa-uat-preprod-112ea",
    storageBucket: "omni-dev-qa-uat-preprod-112ea.firebasestorage.app",
    messagingSenderId: "499468199349",
    appId: "1:499468199349:web:a06b9aaed3e3741ee5a5fc",
    measurementId: "G-VSK6N8CTR4"
  }
};
